<template>
    <div>
        <div class="container sm:px-10">
            <div class="block xl:grid grid-cols-2 gap-4">
                <!-- BEGIN: Login Info -->
                <div class="hidden xl:flex flex-col min-h-screen">
                    <a href="" class="-intro-x flex items-center pt-5">
                        <img alt="Midone Tailwind HTML Admin Template" class="w-6" :src="require(`@/assets/images/logo.svg`)" />
                        <span class="text-white text-lg ml-3">
                            FIRECAM <span class="font-medium text-theme-12">C.A.E.</span>
                        </span>
                    </a>
                    <div class="my-auto">
                        <img alt="Midone Tailwind HTML Admin Template" class="-intro-x w-1/2 -mt-16" :src="require(`@/assets/images/illustration.svg`)" />
                        <div class="-intro-x text-white font-medium text-4xl leading-tight mt-10">
                            Accede a tu cuenta <br />
                            de FIRECAM <span class="text-theme-12 font-bold">C.A.E.</span>
                        </div>
                        <div class="-intro-x mt-5 text-lg text-white dark:text-gray-500">
                            Gestiona todo tus documentos en un sólo lugar
                        </div>
                    </div>
                </div>
                <!-- END: Login Info -->
                <!-- BEGIN: Login Form -->
                <div class="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
                    <div class="my-auto mx-auto xl:ml-20 bg-white xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto">
                        <h2 class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left">
                            Acceso
                        </h2>
                        <div class="intro-x mt-2 text-gray-500 xl:hidden text-center">
                            Gestiona todo tus documentos en un sólo lugar
                        </div>
                        <div class="intro-x mt-8">
                            <input type="text" v-model="userData.user" class="intro-x login__input input input--lg border border-gray-300 block" placeholder="Usuario" />
                            <div class="intro-x relative mt-4">
                                <input :type="showPassword ? 'text' : 'password'" v-model="userData.password" class="login__input input input--lg border border-gray-300 block w-full pr-10" placeholder="Contraseña" />
                                <button type="button" @click="showPassword = !showPassword" class="absolute top-0 right-0 h-full flex items-center px-3 z-10 text-gray-600 hover:text-gray-800 focus:outline-none" style="background: transparent;" :aria-label="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                                    <EyeOffIcon v-if="showPassword" size="1.2x" />
                                    <EyeIcon v-else size="1.2x" />
                                </button>
                            </div>
                            <select v-if="centros.length" v-model="userData.centro" class="intro-x login__input input input--lg border border-gray-300 block mt-4">
                                <option value=null>Selecciona centro</option>
                                <option v-for="centro in centros" :value="centro.num">{{centro.nombre_del_centro}}</option>
                            </select>
                        </div>
                        <div class="intro-x flex text-gray-700 dark:text-gray-600 text-xs sm:text-sm mt-4">
                            <!-- <button @click="recordar()">Recordar contraseña?</button> -->
                        </div>
                        <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
                            <button v-if="!centros.length" @click="login" class="flex flex-start items-center hover:bg-black button button--lg w-full xl:w-64 text-white bg-theme-1 xl:mr-3 align-top">
                                <SearchIcon class="mr-4"></SearchIcon>Buscar centro
                            </button>
                            <button v-if="userData.centro" @click="login" class="flex flex-start items-center hover:bg-black button button--lg w-full xl:w-64 text-white bg-theme-1 xl:mr-3 align-top">
                                <LogInIcon class="mr-4"></LogInIcon>Entrar
                            </button>
                        </div>
                        <p v-if="error" class="mt-4 text-red-400">{{error}}</p>
                    </div>
                </div>
                <!-- END: Login Form -->
            </div>
        </div>
    </div>
</template>
<style>
.login .mobile-menu,
.login .side-nav {
    display: none;
}
</style>
<script>
export default {
    data() {
        return {
            logued: false,
            showPassword: false,
            userData: {
                user: "",
                password: "",
                centro: null
            },
            error: '',
            centros: []
        }
    },
    mounted() {
        cash("body")
            .removeClass("app")
            .addClass("login");
    },
    methods: {
        login() {
            this.error = '';
            CmsApi.hook("/hooks/login/", { user: this.userData.user, password: this.userData.password, centro: this.userData.centro, action: "login" }, (data) => {
                if (data.success) {
                    if (data.centros) this.centros = data.centros;
                    if(data.is_admin) {
                        this.$router.push("/");
                    }
                    if(data.centro) {
                        this.$router.push("/");
                    }
                } else {
                    this.error = 'Usuario o contraseña inválidos.';
                }
            });
        },
        recordar() {
            console.info("ya no falta recordar");
        }
    }
};
</script>